export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const LANDING = '/public';
export const HOME = '/';
export const ACCOUNT = '/account';
export const PASSWORD_FORGET = '/pw-forget';

export const DASHBOARD = '/dashboard'
export const CUSTOMERS = '/customers'
export const REGIONS = '/regions'
export const EQUIPMENTS = '/equipments'
export const NOTIFICATIONS = '/notifications'
export const SCHEDULER = '/scheduler'